import { render, staticRenderFns } from "./top-up-table.vue?vue&type=template&id=08f2a93c&scoped=true&"
import script from "./top-up-table.vue?vue&type=script&lang=js&"
export * from "./top-up-table.vue?vue&type=script&lang=js&"
import style0 from "./top-up-table.vue?vue&type=style&index=0&id=08f2a93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2a93c",
  null
  
)

export default component.exports